
import { all, compose, includes, __ } from "ramda";
import { mapState } from "vuex";

export default {
  props: { selectedVariant: { type: Object, required: true } },

  computed: {
    ...mapState(["siteConfig"]),
    comfortFeel() {
      return this.selectedVariant?.mattress_comfort_feel;
    },
    coefficient() {
      const coef = Number(this.selectedVariant?.mattress_coefficient);
      return Number.isNaN(coef) ? 0 : coef;
    },
    doubleComfortFeel() {
      const valueL = this.selectedVariant?.mattress_comfort_feel_left;
      const valueR = this.selectedVariant?.mattress_comfort_feel_right;

      if (!valueL || !valueR) {
        return [];
      }

      const coefL = Number(this.selectedVariant?.mattress_left_coefficient);
      const coefR = Number(this.selectedVariant?.mattress_right_coefficient);

      if (!coefL || Number.isNaN(coefL) || !coefR || Number.isNaN(coefR)) {
        return [];
      }

      return [
        {
          value: valueL,
          coefficient: Number(coefL),
          key: "left",
        },
        {
          value: valueR,
          coefficient: Number(coefR),
          key: "right",
        },
      ];
    },
    tripleComfortFeel() {
      const value = this.selectedVariant?.mattress_comfort_feel;
      const valueL = this.selectedVariant?.mattress_comfort_feel_left;
      const valueR = this.selectedVariant?.mattress_comfort_feel_right;

      if (!value || !valueL || !valueR) {
        return [];
      }

      const coef = Number(this.selectedVariant?.mattress_coefficient);
      const coefL = Number(this.selectedVariant?.mattress_left_coefficient);
      const coefR = Number(this.selectedVariant?.mattress_right_coefficient);

      if (
        !coef ||
        Number.isNaN(coef) ||
        !coefL ||
        Number.isNaN(coefL) ||
        !coefR ||
        Number.isNaN(coefR)
      ) {
        return [];
      }

      return [coef, coefL, coefR];
    },
    showComfortFeel() {
      const scales = this.siteConfig?.pdp?.comfortFeel?.scales;
      const hasCoefficient = includes(__, scales);

      if (this.doubleComfortFeel.length > 0) {
        return all(
          compose(hasCoefficient, x => x?.coefficient),
          this.doubleComfortFeel
        );
      }

      return this.comfortFeel && hasCoefficient(this.coefficient);
    },
  },
};
